module.exports = __webpack_public_path__ + "media/images/area-badges/ecological-explorations-154306407a481e122ee96fd029ee887b.svg";